import Vue from 'vue';
import VueAgileOverride from 'Components/vue_agile_override/VueAgileOverride';

Vue.use(VueAgileOverride);
